var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.tab, ( _obj = {}, _obj[_vm.$style['tab--selected']] = _vm.isSelected, _obj )],on:{"click":_vm.onClick}},[_c('router-link',{class:_vm.$style.tab__text,attrs:{"to":_vm.path,"data-test-id":"tabTitle"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }